import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-nav-user-buttons',
    templateUrl: './nav-user-buttons.component.html',
    styleUrls: ['./nav-user-buttons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavUserButtonsComponent {
    helpURL = environment.helpURL;
    @Input('username') username: string;
}
